

import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { baseApi } from '../../ConfigApi'
import { ConsumptionFormType, TypeConsumptionPage } from '../../pages/consumptions/_types'
import { ContractPagePeriodType, ContractPageType } from '../../pages/contract/ContractPage.types'
import { MainPageType } from '../../pages/main/MainPage.types'
import { AppealType, ContractsArrType } from '../../pages/support/types'
import { UserProfileType } from '../../pages/userProfile/types'
import { ComparisonFormType, ConsByMonthDayFormType, SaldoFormType } from '../../pages/analytics/common.types'

import { isIterableArray } from '../../utils/utils'

import moment from 'moment'
import 'moment/locale/uk'
import { RolesType } from '../../utils/roles'
import { SerializedError } from '@reduxjs/toolkit'

const isDataCheckComparisonBar = (arr: any) => {
    for (let i = 0; i < arr.length; i++) {
        if (Object.keys(arr[i]).length > 1) {
            return true;
        }
    }
    return false;
}
const getSumArr = (arr: number[]) => arr.reduce((a: number, i: number) => (a + i))

const CACHE_DEFAULT_TIME = 100

// const baseQuery = fetchBaseQuery({
//     baseUrl: baseApi,
//     prepareHeaders: (headers, { getState }: any) => {
//         const token = getState().auth.token
//         if (token) {
//             headers.set('authorization', token)
//         }
//         return headers
//     },
// })

// const baseQueryWith403: BaseQueryFn<
//     string | FetchArgs | any,
//     unknown,
//     FetchBaseQueryError
// > = async (args, api, extraOptions) => {
//     const result = await baseQuery(args, api, extraOptions)

//     if (result.error?.status === 403) {
//         console.log(result, args, api, extraOptions)

//         // делаем редирект со всех страниц кроме аналитики
//         // тк. в аналитике много запросов и должна быть возможность видеть другие блоки 
//         if (!args?.url?.includes('/api/analitic/')) {
//             // api.dispatch(redirect('/forbidden'))
//         }
//     }

//     return result
// } 
const transform403Response = (response: any): { forbidden: true, }
    | FetchBaseQueryError
    | SerializedError => {
    if (response.status === 403) {
        return { ...response, forbidden: true };
    }
    return response;
}
const baseQueryWithAuth: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions)

    if (result.error?.status === 401) {
        localStorage.removeItem('userToken')
        window.location.href = '/auth'
    }
    return result
}
const baseQuery = fetchBaseQuery({
    baseUrl: baseApi,
    prepareHeaders: (headers, { getState }: any) => {
        const token = getState().auth.token
        if (token) {
            // include token in req header
            headers.set('authorization', `${token}`)
            return headers
        }
        else {
            window.location.href = '/auth'
        }
    },
})
export const authApi = createApi({
    reducerPath: 'authApi',
    keepUnusedDataFor: 0,
    baseQuery: baseQueryWithAuth,

    endpoints: (builder) => ({
        viewConsumptionByMonthByDayPrice: builder.query<any, ConsByMonthDayFormType>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: ConsByMonthDayFormType) => ({
                url: '/api/analitic/consumption-comparison/view-by-month-or-day',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {
                const labels: number[] = []

                const rdn: number[] = []
                const transfer: number[] = []
                const class1: number[] = []
                const class2: number[] = []

                const isData = isIterableArray(response) ? isDataCheckComparisonBar(response) : false
                if (isIterableArray(response)) response.forEach((element: any, index: number) => {
                    labels.push(++index)
                    rdn.push(element?.rdn?.price || 0)
                    transfer.push(element?.transfer?.price || 0)
                    class1.push(element?.class1?.price || 0)
                    class2.push(element?.class2?.price || 0)

                })

                const legendKeys = []
                const is_rdn = getSumArr(rdn)
                const is_transfer = getSumArr(transfer)
                const is_class1 = getSumArr(class1)
                const is_class2 = getSumArr(class2)
                if (is_rdn) legendKeys.push('rdn')
                if (is_transfer) legendKeys.push('transfer')
                if (is_class1) legendKeys.push('class1')
                if (is_class2) legendKeys.push('class2')

                return {
                    month: response?.month,
                    isForSave: isData,
                    legendKeys: legendKeys,
                    formatted: {
                        labels,
                        rdn,
                        transfer,
                        class1,
                        class2,
                    }
                }
            }
        }),
        viewConsumptionByMonthByDay: builder.query<any, ConsByMonthDayFormType>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: ConsByMonthDayFormType) => ({
                url: '/api/analitic/consumption-comparison/view-by-month-or-day',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {
                const labels: number[] = []

                const rdn: number[] = []
                const transfer: number[] = []
                const class1: number[] = []
                const class2: number[] = []

                const isData = isIterableArray(response) ? isDataCheckComparisonBar(response) : false
                if (isIterableArray(response)) response.forEach((element: any, index: number) => {
                    labels.push(++index)
                    rdn.push(element?.rdn?.total_for_act || 0)
                    transfer.push(element?.transfer?.total_for_act || 0)
                    class1.push(element?.class1?.total_for_act || 0)
                    class2.push(element?.class2?.total_for_act || 0)

                })

                const legendKeys = []
                const is_rdn = getSumArr(rdn)
                const is_transfer = getSumArr(transfer)
                const is_class1 = getSumArr(class1)
                const is_class2 = getSumArr(class2)
                if (is_rdn) legendKeys.push('rdn')
                if (is_transfer) legendKeys.push('transfer')
                if (is_class1) legendKeys.push('class1')
                if (is_class2) legendKeys.push('class2')

                return {
                    month: response?.month,
                    legendKeys: legendKeys,
                    isForSave: isData,
                    formatted: {
                        labels,
                        rdn,
                        transfer,
                        class1,
                        class2,
                    }
                }
            }
        }),
        viewComparisonByYear: builder.query<any, {
            contract_id?: number,
            periodFrom: string,
            periodTo: string
        }>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id?: number,
                periodFrom: string,
                periodTo: string
            }) => ({
                url: '/api/analitic/consumption-comparison/view-by-year',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {
                const labels: string[] = []
                const labels_string: string[] = []

                const rdn: number[] = []
                const transfer: number[] = []
                const class1: number[] = []
                const class2: number[] = []

                const isData = isIterableArray(response) ? isDataCheckComparisonBar(response) : false
                if (isIterableArray(response)) response.forEach((element: any) => {
                    labels.push(element.period)
                    labels_string.push(moment(element.period, 'YYYY-MM').format('MMMM YYYY'))
                    rdn.push(element?.rdn?.total_for_act || 0)
                    transfer.push(element?.transfer?.total_for_act || 0)
                    class1.push(element?.class1?.total_for_act || 0)
                    class2.push(element?.class2?.total_for_act || 0)

                })

                const legendKeys = []
                const is_rdn = getSumArr(rdn)
                const is_transfer = getSumArr(transfer)
                const is_class1 = getSumArr(class1)
                const is_class2 = getSumArr(class2)
                if (is_rdn) legendKeys.push('rdn')
                if (is_transfer) legendKeys.push('transfer')
                if (is_class1) legendKeys.push('class1')
                if (is_class2) legendKeys.push('class2')

                return {
                    month: response?.month,
                    isForSave: isData,
                    legendKeys: legendKeys,
                    formatted: {
                        labels,
                        labels_string,
                        rdn,
                        transfer,
                        class1,
                        class2,
                    }
                }
            }
        }),
        viewComparisonByYearPrice: builder.query<any, {
            contract_id?: number,
            periodFrom: string,
            periodTo: string
        }>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id?: number,
                periodFrom: string,
                periodTo: string
            }) => ({
                url: '/api/analitic/consumption-comparison/view-by-year',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {
                const labels: string[] = []
                const labels_string: string[] = []

                const rdn: number[] = []
                const transfer: number[] = []
                const class1: number[] = []
                const class2: number[] = []

                if (isIterableArray(response)) response.forEach((element: any) => {
                    labels.push(element.period)
                    labels_string.push(moment(element.period, 'YYYY-MM').format('MMMM YYYY'))
                    rdn.push(element?.rdn?.price || 0)
                    transfer.push(element?.transfer?.price || 0)
                    class1.push(element?.class1?.price || 0)
                    class2.push(element?.class2?.price || 0)

                })

                const isData = isIterableArray(response) ? isDataCheckComparisonBar(response) : false

                const legendKeys = []
                const is_rdn = getSumArr(rdn)
                const is_transfer = getSumArr(transfer)
                const is_class1 = getSumArr(class1)
                const is_class2 = getSumArr(class2)
                if (is_rdn) legendKeys.push('rdn')
                if (is_transfer) legendKeys.push('transfer')
                if (is_class1) legendKeys.push('class1')
                if (is_class2) legendKeys.push('class2')


                return {
                    isForSave: isData,
                    legendKeys: legendKeys,
                    formatted: {
                        labels,
                        labels_string,
                        rdn,
                        transfer,
                        class1,
                        class2,
                    }
                }
            }
        }),
        viewComparison: builder.query<any, ComparisonFormType>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: ComparisonFormType) => ({
                url: '/api/analitic/consumption-comparison/view-by-period',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {

                const KEYVAL1 = 'price'
                const KEYVAL2 = 'total_for_act'

                // распарсенные данные 1 периода
                // values1 - значения price всех элементов
                // values2 - значения total_for_act всех элементов
                const formatted1 = isIterableArray(Object.keys(response.period1)) ?
                    Object.keys(response.period1).reduce((acc: any, key: any) => {


                        const item = response.period1[key]
                        if (item?.[KEYVAL1]) {
                            acc.values1.push(item?.[KEYVAL1])
                            acc.labels1.push(key)
                        }
                        if (item?.[KEYVAL2]) {
                            acc.values2.push(item?.[KEYVAL2])
                            acc.labels2.push(key)
                        }
                        if (item.hasOwnProperty(KEYVAL1) && item.hasOwnProperty(KEYVAL2)) {
                            acc.originData = { ...acc.originData, ...{ [key]: item } }
                        }
                        return acc
                    }, {
                        values1: [],
                        labels1: [],
                        values2: [],
                        labels2: [],
                        originData: {},
                    })
                    :
                    false

                const formatted2 = isIterableArray(Object.keys(response.period2)) ?
                    Object.keys(response.period2).reduce((acc: any, key: any) => {


                        const item = response.period2[key]
                        if (item?.[KEYVAL1]) {
                            acc.values1.push(item?.[KEYVAL1])
                            acc.labels1.push(key)
                        }
                        if (item?.[KEYVAL2]) {
                            acc.values2.push(item?.[KEYVAL2])
                            acc.labels2.push(key)
                        }
                        if (item.hasOwnProperty(KEYVAL1) && item.hasOwnProperty(KEYVAL2)) {
                            acc.originData = { ...acc.originData, ...{ [key]: item } }
                        }
                        return acc
                    }, {
                        values1: [],
                        labels1: [],
                        values2: [],
                        labels2: [],
                        originData: {}
                    })
                    :
                    false
                return {
                    formatted: {
                        period1: {
                            consumption: {
                                declared: response.period1.declared,
                                fact: response.period1.fact,
                                delta_cons: Math.abs(response.period1.delta_cons),
                            },
                            originData: formatted1.originData,
                            dataPrice: { // tarif
                                values: formatted1 ? formatted1.values1 : null,
                                labels: formatted1 ? formatted1.labels1 : null
                            },
                            dataTotal: {
                                values: formatted1 ? formatted1.values2 : null,
                                labels: formatted1 ? formatted1.labels2 : null
                            },
                        },
                        period2: {
                            consumption: {
                                declared: response.period2.declared,
                                fact: response.period2.fact,
                                delta_cons: Math.abs(response.period2.delta_cons),
                            },
                            originData: formatted2.originData,
                            dataPrice: { // tarif
                                values: formatted2 ? formatted2.values1 : null,
                                labels: formatted2 ? formatted2.labels1 : null
                            },
                            dataTotal: {
                                values: formatted2 ? formatted2.values2 : null,
                                labels: formatted2 ? formatted2.labels2 : null
                            },
                        },
                    }
                }
            }
        }),
        viewSaldo: builder.query<any, SaldoFormType>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: SaldoFormType) => ({
                url: '/api/ca/view-saldo',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {
                const labels: string[] = []
                const balance: number[] = []
                const sum_invoice: number[] = []
                const sum_payment: number[] = []

                response.forEach((element: any) => {
                    labels.push(element.date)
                    balance.push(element.balance)
                    sum_invoice.push(element.sum_invoice)
                    sum_payment.push(element.sum_payment)
                })
                return {
                    response: response,
                    formatted: {
                        labels,
                        balance,
                        sum_invoice,
                        sum_payment,
                    }
                }
            }
        }),
        viewConsumption: builder.query<any, {
            contract_id?: number,
            periodFrom: string,
            periodTo: string
        }>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
                periodFrom: string,
                periodTo: string
            }) => ({
                url: '/api/ca/view-consumption',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {
                const labels: string[] = []
                const labels_string: string[] = []
                const declared: number[] = []
                const declared_origin: number[] = []
                const fact: number[] = []
                const declared_delta_less_6: number[] = []
                const declared_delta_more_6: number[] = []

                if (isIterableArray(response.month)) response.month.forEach((element: any) => {
                    const lab = moment(`${element.month}-${element.year}`, 'MM-YYYY').locale("uk").format('MMMM YY')
                    const label = lab[0].toUpperCase() + lab.slice(1)
                    labels_string.push(label)
                    labels.push(`${element.month}-${element.year}`)
                    // declared.push(element.declared > element.fact ? element.fact : element.declared)
                    declared.push(element.declared > element.fact ?
                        (element.fact ? element.fact : element.declared)
                        :
                        element.declared
                    )
                    declared_origin.push(element.declared)
                    fact.push(element.fact)
                    if (element.declared > element.fact) {
                        const delta_procent = (Math.abs(element.delta) / element.fact) * 100
                        // const delta_procent = (element.declared * 100) / element.fact
                        if (delta_procent >= 6) {
                            declared_delta_less_6.push(0)
                            declared_delta_more_6.push(element.fact > 0 ? Math.abs(element.delta) : 0)
                        } else if (delta_procent < 6) {
                            declared_delta_less_6.push(element.fact > 0 ? Math.abs(element.delta) : 0)
                            declared_delta_more_6.push(0)
                        }
                        else {
                            declared_delta_less_6.push(0)
                            declared_delta_more_6.push(0)
                        }
                    }
                    else if (element.declared < element.fact) {
                        const delta_procent = (Math.abs(element.delta) / element.fact) * 100
                        // const delta_procent = (element.declared * 100) / element.fact
                        if (delta_procent >= 6) {
                            declared_delta_more_6.push(element.declared > 0 ? Math.abs(element.delta) : 0)
                            declared_delta_less_6.push(0)
                        } else if (delta_procent < 6) {
                            declared_delta_less_6.push(0)
                            declared_delta_more_6.push(element.declared > 0 ? Math.abs(element.delta) : 0)
                        }
                        else {
                            declared_delta_less_6.push(0)
                            declared_delta_more_6.push(0)
                        }
                    }
                    else {
                        declared_delta_less_6.push(0)
                        declared_delta_more_6.push(0)
                    }
                })
                const isDataCheck = (arrMonth: any) => {
                    for (let i = 0; i < arrMonth.length; i++) {
                        if (arrMonth?.[i]?.declared > 0 || arrMonth?.[i]?.delta > 0 || arrMonth?.[i]?.fact > 0) {
                            return true;
                        }
                    }
                    return false;
                }
                const isData = isIterableArray(response.month) ? isDataCheck(response.month) : false

                const legendKeys = []
                const is_declared = getSumArr(declared)
                const is_fact = getSumArr(fact)
                const is_declared_delta_less_6 = getSumArr(declared_delta_less_6)
                const is_declared_delta_more_6 = getSumArr(declared_delta_more_6)

                if (is_declared) legendKeys.push('declared')
                if (is_fact) legendKeys.push('fact')
                if (is_declared_delta_less_6) legendKeys.push('declared_delta_less_6')
                if (is_declared_delta_more_6) legendKeys.push('declared_delta_more_6')


                return {
                    month: response.month,
                    isForSave: isData,
                    legendKeys: legendKeys,
                    formatted: {
                        labels,
                        labels_string,
                        declared,
                        declared_origin,
                        fact,
                        declared_delta_less_6,
                        declared_delta_more_6,
                    }
                }
            }
        }),
        viewConsumptionMonth: builder.query<any, {
            contract_id: number,
            period: string
        }>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
                period: string,
            }) => ({
                url: '/api/analitic/consumption-month/view',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {
                const labels: string[] = []

                const declared_origin: number[] = []
                const total_declared: number[] = []
                const total_fact: number[] = []

                const declared_delta_less_6: number[] = []
                const declared_delta_more_6: number[] = []

                if (isIterableArray(response.array_cons)) {
                    response.array_cons.forEach((element: any) => {
                        labels.push(element.day)

                        total_declared.push(element.total_declared > element.total_fact ?
                            (element.total_fact ? element.total_fact : element.total_declared)
                            :
                            element.total_declared
                        )
                        // total_declared.push(element.total_declared > element.total_fact ? element.total_fact : element.total_declared)
                        total_fact.push(element.total_fact)
                        declared_origin.push(element.total_declared)
                        if (element.total_declared > element.total_fact) {
                            const delta_procent = (Math.abs(element.delta) / element.total_fact) * 100
                            // const delta_procent = (element.total_declared * 100) / element.total_fact
                            if (delta_procent >= 6) {
                                declared_delta_less_6.push(0)
                                declared_delta_more_6.push(element.total_fact > 0 ? Math.abs(element.delta) : 0)
                            } else if (delta_procent < 6) {
                                declared_delta_less_6.push(element.total_fact > 0 ? Math.abs(element.delta) : 0)
                                declared_delta_more_6.push(0)
                            }
                            else {
                                declared_delta_less_6.push(0)
                                declared_delta_more_6.push(0)
                            }
                        }
                        else if (element.total_declared < element.total_fact) {
                            const delta_procent = (Math.abs(element.delta) / element.total_fact) * 100
                            // const delta_procent = (element.total_declared * 100) / element.total_fact
                            if (delta_procent > 6) {
                                declared_delta_more_6.push(element.total_declared > 0 ? Math.abs(element.delta) : 0)
                                declared_delta_less_6.push(0)
                            } else if (delta_procent < 6) {
                                declared_delta_less_6.push(element.total_declared > 0 ? Math.abs(element.delta) : 0)
                                declared_delta_more_6.push(0)
                            }
                            else {
                                declared_delta_less_6.push(0)
                                declared_delta_more_6.push(0)
                            }
                        }
                        else {
                            declared_delta_less_6.push(0)
                            declared_delta_more_6.push(0)
                        }
                    })

                    const legendKeys = []
                    const is_declared = getSumArr(total_declared)
                    const is_fact = getSumArr(total_fact)
                    const is_declared_delta_less_6 = getSumArr(declared_delta_less_6)
                    const is_declared_delta_more_6 = getSumArr(declared_delta_more_6)

                    if (is_declared) legendKeys.push('declared')
                    if (is_fact) legendKeys.push('fact')
                    if (is_declared_delta_less_6) legendKeys.push('declared_delta_less_6')
                    if (is_declared_delta_more_6) legendKeys.push('declared_delta_more_6')

                    const isDataCheck = (arrMonth: any) => {
                        for (let i = 0; i < arrMonth.length; i++) {
                            if (arrMonth?.[i]?.total_declared > 0 || arrMonth?.[i]?.delta > 0 || arrMonth?.[i]?.total_fact > 0) {
                                return true;
                            }
                        }
                        return false;
                    }

                    const isData = isIterableArray(response.array_cons) ? isDataCheck(response.array_cons) : false

                    return {
                        legendKeys: legendKeys,
                        isForSave: isData,
                        formatted: {
                            labels,
                            declared: total_declared,
                            fact: total_fact,
                            declared_origin,
                            declared_delta_less_6,
                            declared_delta_more_6
                        }
                    }
                }
                else return {
                    formatted: false
                }
            }
        }),
        viewConsumptionDay: builder.query<any, {
            contract_id: number,
            period: string,
            day: number
        }>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
                period: string,
                day: number
            }) => ({
                url: '/api/analitic/consumption-day/view',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {

                const data_declared: number[] = []
                const data_cons: number[] = []
                const declared_delta_less_6: number[] = []
                const declared_delta_more_6: number[] = []


                if (isIterableArray(response.data_cons)) {
                    response.data_cons.forEach((_: any, index: number) => {

                        // data_declared - Plan
                        // data_cons - Fakt

                        data_cons.push(response.data_cons[index])

                        data_declared.push(response.data_declared[index] > response.data_cons[index] ?
                            (response.data_cons[index] ? response.data_cons[index] : response.data_declared[index])
                            :
                            response.data_declared[index]
                        )
                        // data_declared.push(response.data_declared[index] > response.data_cons[index] ? response.data_cons[index] : response.data_declared[index])

                        if (response.data_declared[index] > response.data_cons[index]) {
                            const delta_procent = (Math.abs(response.data_cons[index] - response.data_declared[index]) / response.data_declared[index]) * 100
                            // const delta_procent = (response.data_cons[index] * 100) / response.data_declared[index]
                            if (delta_procent >= 6) {
                                declared_delta_less_6.push(0)
                                declared_delta_more_6.push(response.data_cons[index] > 0 ? Math.abs(response.data_cons[index] - response.data_declared[index]) : 0)
                            } else if (delta_procent < 6) {
                                declared_delta_less_6.push(response.data_cons[index] > 0 ? Math.abs(response.data_cons[index] - response.data_declared[index]) : 0)
                                declared_delta_more_6.push(0)
                            }
                            else {
                                declared_delta_less_6.push(0)
                                declared_delta_more_6.push(0)
                            }
                        }
                        else if (response.data_declared[index] < response.data_cons[index]) {
                            const delta_procent = (Math.abs(response.data_cons[index] - response.data_declared[index]) / response.data_declared[index]) * 100
                            // const delta_procent = (response.data_cons[index] * 100) / response.data_declared[index]
                            if (delta_procent > 6) {
                                declared_delta_more_6.push(response.data_declared[index] > 0 ? Math.abs(response.data_cons[index] - response.data_declared[index]) : 0)
                                declared_delta_less_6.push(0)
                            } else if (delta_procent < 6) {
                                declared_delta_less_6.push(response.data_declared[index] > 0 ? Math.abs(response.data_cons[index] - response.data_declared[index]) : 0)
                                declared_delta_more_6.push(0)
                            }
                            else {
                                declared_delta_less_6.push(0)
                                declared_delta_more_6.push(0)
                            }
                        }
                        else {
                            declared_delta_less_6.push(0)
                            declared_delta_more_6.push(0)
                        }
                    })

                    const legendKeys = []
                    const is_declared = getSumArr(data_declared)
                    const is_data_cons = getSumArr(data_cons)
                    const is_declared_delta_less_6 = getSumArr(declared_delta_less_6)
                    const is_declared_delta_more_6 = getSumArr(declared_delta_more_6)

                    if (is_declared) legendKeys.push('data_declared')
                    if (is_data_cons) legendKeys.push('data_cons')
                    if (is_declared_delta_less_6) legendKeys.push('declared_delta_less_6')
                    if (is_declared_delta_more_6) legendKeys.push('declared_delta_more_6')

                    const isDataCheck = (arrMonth: any) => {
                        for (let i = 0; i < arrMonth.length; i++) {
                            if (arrMonth?.data_declared?.[i] > 0 || arrMonth?.data_cons?.[i] > 0) {
                                return true;
                            }
                        }
                        return false;
                    }


                    const isData = !!is_declared || !!is_data_cons


                    return {
                        legendKeys: legendKeys,
                        isForSave: isData,
                        formatted: {
                            declared_origin: response.data_declared,
                            data_declared: data_declared,
                            data_cons: data_cons,
                            declared_delta_less_6,
                            declared_delta_more_6
                        }
                    }
                }
                else return {
                    formatted: false
                }
            }
        }),

        // DEPRICATE
        viewConsumptionDetailMonth: builder.query<any, {
            contract_id: number,
            period: string
        }>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
                period: string,
            }) => ({
                url: '/api/analitic/consumption-detail/view',
                method: 'POST',
                body
            }),
            // transformResponse: (response: any) => {
            //     const KEYVAL1 = 'price'
            //     const KEYVAL2 = 'total_for_act'

            //     const formatted = isIterableArray(Object.keys(response)) ? Object.keys(response).reduce((acc: any, key: any) => {
            //         const item = response[key]
            //         console.log(key, item)
            //         if (item?.[KEYVAL1]) {
            //             acc.values1.push(item?.[KEYVAL1])
            //             acc.labels1.push(key)
            //         }
            //         if (item?.[KEYVAL2]) {
            //             acc.values2.push(item?.[KEYVAL2])
            //             acc.labels2.push(key)
            //         }
            //         return acc
            //     }, {
            //         // price: {
            //         //     values: [],
            //         //     labels: [],
            //         // },
            //         // total_for_act: {
            //         //     values: [],
            //         //     labels: [],
            //         // },
            //         values1: [],
            //         labels1: [],
            //         values2: [],
            //         labels2: [],
            //     }) : false

            //     console.log(formatted)

            //     return {
            //         formatted: formatted,
            //         response: response
            //     }
            // }
        }),
        viewConsumptionDetailPeriod: builder.query<any, {
            contract_id: number,
            periodFrom: string,
            periodTo: string,
        }>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
                periodFrom: string,
                periodTo: string,
            }) => ({
                url: '/api/analitic/consumption-detail/view-by-period',
                method: 'POST',
                body
            }),
        }),
        contractBalancesView: builder.query<any, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
            }) => ({
                url: '/api/ca/view-balance',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {
                return { ...response, ...{ legal_address: response.address } }
            }
        }),
        invoiceHistoryView: builder.query<any, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
                invoiceId: number,
            }) => ({
                url: '/api/invoice/view-saldo',
                method: 'POST',
                body
            }),
            transformErrorResponse: transform403Response,
        }),
        invoicesView: builder.query<any, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
                type: number[],
                periodFrom: string,
                periodTo: string,
                balance: number[],
                date_payment: string[]
            }) => ({
                url: '/api/invoice/view-filter',
                method: 'POST',
                body
            }),
            transformErrorResponse: transform403Response,
        }),
        actsView: builder.query<any, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
                type: number[],
                periodFrom: string,
                periodTo: string,
                balance: number[],
                date_payment: string[]
            }) => ({
                url: '/api/acts/view-filter',
                method: 'POST',
                body
            }),
            transformErrorResponse: transform403Response,
            transformResponse: (response: any) => {
                return { ...response, ...{ legal_address: response.address } }
            }
        }),
        balancesView: builder.query<any, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
                periodFrom: string,
                periodTo: string,
                balances: number[],
            }) => ({
                url: '/api/ca/view-balance-period',
                method: 'POST',
                body
            })
        }),
        paymentsView: builder.query<any, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                contract_id: number,
                type: number[],
                type_invoice: number[],
                balance: number[],
                date_payment: string[]
            }) => ({
                url: '/api/payments/view-filter',
                method: 'POST',
                body
            }),
            transformErrorResponse: transform403Response,
        }),
        viewDeclaredGas: builder.query<any, {
            contract_id: number,
            id: number
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-gas/view-gas',
                method: 'POST',
                body
            })
        }),
        viewDeclaredGasAll: builder.query<any, {
            contract_id: number,
            arr_gas: number[]
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-gas/view-gas-all',
                method: 'POST',
                body
            })
        }),
        viewDeclaredPower: builder.query<any, {
            contract_id: number,
            id: number
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-gas/view-power',
                method: 'POST',
                body
            })
        }),
        viewDeclaredPowerAll: builder.query<any, {
            contract_id: number,
            arr_power: number[]
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-gas/view-power-all',
                method: 'POST',
                body
            })
        }),
        viewFactualGas: builder.query<any, {
            id: number,
            contract_id: number,
            arr_gas: number[],
            arr_power: number[],
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-gas/view-fact',
                method: 'POST',
                body
            }),
        }),
        viewFactualGasAll: builder.query<any, {
            id: number,
            contract_id: number,
            arr_fact: number[],
            arr_gas: number[],
            arr_power: number[],
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-gas/view-fact-all',
                method: 'POST',
                body
            }),
        }),
        viewFactInfoTkoGas: builder.query<any, {
            id?: number,
            contract_id: number
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-gas/info-tko',
                method: 'POST',
                body
            }),
        }),
        gasConsumptionView: builder.query<TypeConsumptionPage, ConsumptionFormType>({
            query: (body) => ({
                url: '/api/ca/consumption-gas/view-all',
                method: 'POST',
                body
            })
        }),
        consumptionViewAllTko: builder.query<any, {
            contract_id: number,
        }>({
            query: (body: {
                contract_id: number,
                service_id: number
            }) => ({
                url: `/api/ca/consumption/all-tko`,
                method: 'POST',
                body: {
                    contract_id: body.contract_id,
                }
            }),
            transformResponse: (response: any) => {
                const replaced = isIterableArray(response) ? response.map((i: any) => ({
                    value: i.id,
                    label: i.name
                })) : []
                return replaced
            }
        }),
        consumptionView: builder.query<TypeConsumptionPage, ConsumptionFormType>({
            query: (body) => ({
                url: `/api/ca/consumption/view-all`,
                method: 'POST',
                body
            }),
            transformErrorResponse: transform403Response
        }),
        // consumptionViewAllTko: builder.query<any, {}>({
        //     query: (body: {
        //         contract_id: number,
        //     }) => ({
        //         url: '/api/ca/consumption/all-tko',
        //         method: 'POST',
        //         body
        //     }),
        //     transformResponse: (response: any) => {
        //         const replaced = isIterableArray(response) ? response.map((i: any) => ({
        //             value: i.id,
        //             label: i.name
        //         })) : []
        //         return replaced
        //     }
        // }),
        viewDeclared: builder.query<any, {}>({
            query: (body: {
                contract_id: number
            }) => ({
                url: '/api/ca/consumption/view-declared',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {
                const formData = isIterableArray(response?.data) ? response.data.reduce((acc: any, item: any) => {
                    if (isIterableArray(item.data)) {
                        item.data.map((tko: any) => {
                            acc = {
                                ...acc,
                                ... { [`${item.tko.id}-${tko.month}-${tko.year}`]: typeof tko.declared?.amount === 'number' ? tko.declared?.amount : '' }
                                // CHECK THIS!!!
                            }
                        })
                    }
                    return acc
                }, {})
                    :
                    []
                return { ...response, ...{ formData: formData } }
            }
        }),
        viewDetailingInfo: builder.query<any, {
            id: number,
            contract_id: number
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-detailing/view',
                method: 'POST',
                body
            }),
        }),
        viewDetailingMatrix: builder.query<any, {
            tko_id: number,
            month: string,
            year: number,
            contract_id: number,
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-detailing/view-matrix',
                method: 'POST',
                body
            }),
        }),
        viewDetailingAll: builder.query<any, {
            arr_id: number[],
            contract_id: number,
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-detailing/view-matrix-all',
                method: 'POST',
                body
            }),
        }),
        viewFactAll: builder.query<any, {
            fact_id: number[],
            contract_id: number,
            type: number,
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-fact/view-matrix-all',
                method: 'POST',
                body
            }),
        }),
        viewFactual: builder.query<any, {
            // fact_id: number[],
            id: number,
            contract_id: number,
            type: number,
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-fact/view-matrix',
                method: 'POST',
                body
            }),
        }),
        viewFactInfoTko: builder.query<any, {
            id?: number,
            contract_id: number
        }>({
            query: (body) => ({
                url: '/api/ca/consumption-fact/info_tko',
                method: 'POST',
                body
            }),
        }),
        getCompaniesPeriod: builder.query<any, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: { ids: number[] }) => ({
                url: '/api/cabinet/ca/get-date-many-or',
                method: 'POST',
                body
            }),
        }),
        getContractPeriod: builder.query<any, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: { contract_id: number, endOffset?: number }) => ({
                url: '/api/ca/get-date-select',
                method: 'POST',
                body
            }),
        }),
        caView: builder.query<ContractPageType, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: { contract_id: number }) => ({
                url: '/api/ca/view',
                method: 'POST',
                body
            }),
        }),
        caViewPeriod: builder.query<ContractPagePeriodType, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: { contract_id: number, month: string, year: string }) => ({
                url: '/api/ca/view-period',
                method: 'POST',
                body
            })
        }),
        requestGetContractsView: builder.query<ContractsArrType[], {
            service_id: number,
        }>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: { service_id: number }) => ({
                url: '/api/cabinet/profile-request-getcontracts',
                method: 'POST',
                body
            })
        }),
        profileRequestsView: builder.query<AppealType[], {
            periodFrom: string,
            periodTo: string,
        }>({
            query: (body) => ({
                url: '/api/cabinet/profile-requests',
                method: 'POST',
                body
            })
        }),
        profileInfoView: builder.query<UserProfileType, any>({
            query: () => ({
                url: '/api/cabinet/profile-getinfo',
                method: 'GET'
            })
        }),
        getInfoManagerView: builder.query<{
            name: string,
            phone: string,
            email: string,
            avatar: string,
        }, {
            contract_id: number
        }>({
            keepUnusedDataFor: 120,
            query: (body) => ({
                url: `/api/cabinet/profile-getinfomanager/${body.contract_id}`,
                method: 'GET'
            })
        }),
        indexContracts: builder.query({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: { service_id: number }) => ({
                url: '/api/cabinet/index-contracts',
                method: 'POST',
                body
            }),
            transformResponse: (response: any) => {
                const formattedContracts = isIterableArray(response.contracts) ? response.contracts.map((contract: any) => {
                    const forSearch = isIterableArray(contract.items) ? contract.items.reduce((strRes: string, item: any) => {
                        strRes += item.legal_address
                        strRes += ','
                        strRes += item.number
                        strRes += ','
                        strRes += item.or_number
                        strRes += ','
                        if (item?.code1) {
                            strRes += item.code1
                            strRes += ','
                        }
                        if (item?.code2) {
                            strRes += item.code2
                            strRes += ','
                        }
                        return strRes
                    }, '') : ''
                    return { ...contract, ...{ forSearch: forSearch } }
                }) : []
                const legalFilters = isIterableArray(response.contracts) ? response.contracts.reduce((acc: any, item: any) => {
                    acc.push({
                        value: Number(item.id),
                        label: item.name
                    })
                    return acc
                }, []) : []
                return { ...response, ...{ legalFilters: legalFilters, contracts: formattedContracts } }
            }

        }),
        // main
        indexAll: builder.query<MainPageType, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (props = '') => `/api/cabinet/index-all`,
            transformResponse: (response: any) => {
                const count = response?.svet?.active_total + response?.gaz?.active_total
                if (count < 2) {
                    return {
                        navigate: true,
                        ...response
                    }
                }
                return response
            }
        }),
        viewCaAllocation: builder.query<any, {}>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: { contract_id: number }) => ({
                url: `/api/ca/view-allocation`,
                method: 'POST',
                body
            }),
        }),
        viewBalances: builder.query<any, {
            day: string,
            period: string,
            service_id: number,
            ids: number[]
        }>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                day: string,
                period: string,
                service_id: number,
                ids: number[]
            }) => ({
                url: `/api/cabinet/ca/view-saldo-many`,
                method: 'POST',
                body
            }),
        }),
        viewBalancesByContract: builder.query<any, {
            date_from: string,
            date_to: string,
            contract_id: number
        }>({
            keepUnusedDataFor: CACHE_DEFAULT_TIME,
            query: (body: {
                date_from: string,
                date_to: string,
                contract_id: number
            }) => ({
                url: `/api/ca/view-saldo-for-modal`,
                method: 'POST',
                body
            }),
        }),
        getRoles: builder.query<RolesType, void>({
            query: () => ({
                url: '/api/cabinet/get-roles',
                method: 'POST'
            }),
        }),
    }),
})

export const {
    useIndexAllQuery,
    useIndexContractsQuery,
    useCaViewQuery,
    useCaViewPeriodQuery,
    useInvoicesViewQuery,
    useInvoiceHistoryViewQuery,
    useGetContractPeriodQuery,
    useActsViewQuery,
    usePaymentsViewQuery,
    useConsumptionViewQuery,
    useConsumptionViewAllTkoQuery,
    useViewDeclaredQuery,
    useViewDetailingInfoQuery,
    useViewDetailingMatrixQuery,
    useViewFactAllQuery,
    useViewFactInfoTkoQuery,
    useViewFactualQuery,
    useViewDetailingAllQuery,
    useContractBalancesViewQuery,
    useProfileInfoViewQuery,
    useRequestGetContractsViewQuery,
    useProfileRequestsViewQuery,
    useGetInfoManagerViewQuery,
    useViewDeclaredGasQuery,
    useViewDeclaredPowerQuery,
    useViewDeclaredGasAllQuery,
    useViewDeclaredPowerAllQuery,
    useViewFactInfoTkoGasQuery,
    useViewFactualGasQuery,
    useViewFactualGasAllQuery,
    useViewSaldoQuery,
    useViewConsumptionQuery,
    useViewConsumptionMonthQuery,
    useViewConsumptionDayQuery,
    useViewConsumptionDetailMonthQuery,
    useViewComparisonQuery,
    useViewComparisonByYearQuery,
    useViewComparisonByYearPriceQuery,
    useViewCaAllocationQuery,
    useGetCompaniesPeriodQuery,
    useViewBalancesQuery,
    useViewBalancesByContractQuery,
    useViewConsumptionByMonthByDayQuery,
    useViewConsumptionDetailPeriodQuery,
    useViewConsumptionByMonthByDayPriceQuery,
    useBalancesViewQuery,
    useGetRolesQuery
} = authApi
